export default class StaticControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.property = document.createElement('div')
    this.property.id = window.PRIM.getUUID()
    this.property.innerHTML = args.value ? args.value : ''
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.property.id
    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.property)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.property.innerHTML
  }

  setValue (value) {
    this.property.innerHTML = value ? value : ''
  }
}


// WEBPACK FOOTER //
// ./js/lib/ui/StaticControl.js